import React from "react";
import { useParams } from "react-router";
import CalculationDetailContainer from "./components";

const CalculationDetail: React.FC = () => {
  const { calculationId } = useParams<{ calculationId: string }>();
  return <CalculationDetailContainer calculationId={calculationId!} />;
};

export default CalculationDetail;
